import React, { Component } from 'react';
import { EditUserProps, EditUserState } from '../../interfaces/user'
import { connect } from 'react-redux'
import jwt from 'jsonwebtoken'
// import { secretKey } from '../../secret'
// import { addStore, brandsList, channelList, storeTypeList, areasList, countryList } from '../../redux'
import Topbar from '../topbar/topbar'
import Sidebar from '../sidebar/sidebar'
import Footer from '../footer/footer'
import CheckChanges from '../confirmOnLeave';
import { Link, Redirect } from 'react-router-dom';
import { addUser, courseGroupList, getCourseGroupByUser, getUser, groupList, logoutUser, roleList, updateUser } from '../../redux/actions/user';
import config from '../config/setting'
import Select from 'react-select';

class EditUser extends Component<EditUserProps, EditUserState> {
    id: any;
    constructor(props: any) {
        super(props);
        this.id = this.props.match.params.id;
        this.state = {
            name: "",
            role: [],
            group: "",
            courseGroup: [],
            email: "",
            phone: "",
            address: "",
            visaIssue: "",
            visaExpire: "",
            visaImage: "",
            passportExpire: "",
            passportIssue: "",
            passportImage: "",
            status: config.ACTIVE,
            isValidEmail: true,
            isValidPhone: true,
        }
        this.handleSaveBtnClick = this.handleSaveBtnClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        this.props.getUser(this.id);
        this.props.roleList();
        this.props.groupList();
        this.props.courseGroupList();
        this.props.getCourseGroupByUser(this.id);
    }
    componentDidUpdate(prevProps: any) {
        const { user } = this.props;
        if (prevProps.user !== user && user && Object.keys(user).length > 0) {
            const userObj = user;
            console.log("userObj", userObj);
            
            this.setState({
                name: userObj.name || "",
                role: userObj.role?.id || userObj.role || "",
                group: userObj.group?.id || userObj.group || "",
                email: userObj.email || "",
                phone: userObj.phone || "",
                address: userObj.address || "",
                visaIssue: userObj.visaIssue || "",
                visaExpire: userObj.visaExpire || "",
                visaImage: userObj.visaImage || "",
                passportExpire: userObj.passportExpire || "",
                passportIssue: userObj.passportIssue || "",
                passportImage: userObj.passportImage || "",
                status: userObj.status !== undefined ? userObj.status : config.ACTIVE
            });
        }
    }
    handleInputChange(event: { target: { name: any; value: any; }; }) {
        if(event.target.value[0]==" "){
        }else{
          this.setState({
              [event.target.name]: event.target.value,
          });
        }
    }
    VisaFileSelectedHandler = (e: any) => {
        this.setState({ visaImage: e.target.files })
    }
    PassportFileSelectedHandler = (e: any) => {
        this.setState({ passportImage: e.target.files })
    }
    isUserReady = () => {
        const { name, role, group, courseGroup, email, phone, address, status } = this.state
        return (name !== "" && role !== "" && group !== "" && email !== "" && phone !== "" && status !== "" && address !== "");
    }
    handleGroupsInputChange = (e: any) => {
        console.log("eeeeeeeeeee", e);
        if (e && e.value > 0) {
            this.setState({ group: e.value });
        } else {
            this.setState({ group: "" });
        }
    };

    handleItemsInputChange = (e: any) => {
        console.log("e", e);
        let array: any = [];
        e &&
            e.map((obj: any) => {
                array.push(obj.value)
            })
        this.setState({ courseGroup: array })
    };

    validateEmail = (event: { target: { name: any; value: any; }; }) => {
        var reg = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (reg.test(event.target.value) === false) {
          this.setState({ email: event.target.value, isValidEmail: false })
        } else {
          this.setState({ email: event.target.value, isValidEmail: true });
        }
        };
    handlePhoneKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const key = event.key;
        const currentValue = (event.target as HTMLInputElement).value;
        
        // Allow control keys (backspace, delete, tab, arrows)
        const controlKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
        if (controlKeys.includes(key)) {
            return;
        }
        
        // Block non-digit keys
        if (!/^\d$/.test(key)) {
            event.preventDefault();
            return;
        }
        
        // Block if already 11 digits
        if (currentValue.length >= 11) {
            event.preventDefault();
        }
    };

    validatePhone = (event: { target: { name: any; value: any; }; }) => {
        let value = event.target.value;
        // Remove anything that's not a number
        let numericValue = value.replace(/\D/g, "");
        // Trim to max 11 digits
        if (numericValue.length > 11) {
            numericValue = numericValue.slice(0, 11);
        }
        
        this.setState({ phone: numericValue, isValidPhone: true });
    };

    handleSaveBtnClick = (event: any) => {
        let { name, role, group, courseGroup, email, phone, address, status, visaIssue, visaExpire, visaImage, passportExpire, passportIssue, passportImage } = this.state;

        // console.log("visaImage[0]",visaImage[0]);
        // console.log("passportImage[0]",passportImage[0]);

        const data: any = new FormData();
        if (passportImage) {
            data.append('files', passportImage[0]);
        }
        data.append('name', name);
        data.append('role', role);
        data.append('group', group);
        data.append('email', email);
        data.append('phone', phone);
        data.append('address', address);
        data.append('profileImage', passportIssue);
        data.append('status', status);
        //data.append('isActive', );
        this.props.updateUser(this.id, data);
    }
    render() {
        if (sessionStorage.token) {
            jwt.verify(sessionStorage.token, config.secretKey, (err: any, decoded: any) => {
                if (err) {
                    this.props.logoutUser();
                }
            });
        } else {
            return <Redirect to="/" />
        }
        let msg;
        let messcolor;
        let { groups } = this.props;
        let { roles } = this.props;
        let { user } = this.props;

        // Groups Data
        let groupData: any = [];
        let selectedGroup: any = null;
        if (groups.length > 0) {
            groups.forEach((element: any) => {
                var groupp = { value: element.id, label: element.name };
                groupData.push(groupp);

                if(this.state.group && this.state.group == element.id){
                    selectedGroup = groupp;
                }         
            });
        }

        console.log("roles", roles);
        console.log("groups", groups);
        console.log("user", user);

        // user is an object, not an array
        const userObj: any = user && Object.keys(user).length > 0 ? user : {};

        return (
            <div className="page">
                <CheckChanges path="/edit-user" />
                <Topbar />
                <div className="page-content d-flex align-items-stretch">
                    <Sidebar />
                    <div className="content-inner">
                        {/* <!-- Page Header--> */}
                        <header className="page-header pb-1">
                            <div className="container-fluid">
                                <div className="d-flex align-items-center justify-content-between">
                                    <h4>Users Management</h4>
                                </div>
                            </div>
                        </header>
                        {/*  Breadcrumb */}
                        <div className="breadcrumb-holder container-fluid">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/users" className="text-primary">Users</Link></li>
                                <li className="breadcrumb-item active">Edit User</li>
                            </ul>
                        </div>
                        <section className="forms">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body pt-xl-0">
                                                <strong><p className="text-center font-weight-light mb-4" style={{ color: messcolor }}>
                                                    {msg}
                                                </p></strong>

                                                <div className="card-header card-header-info d-flex align-items-center">
                                                    <h5>Personal Information</h5>
                                                </div>

                                                <div className="form-horizontal p-xl-4">

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Name<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="name" type="text" name="name" value={this.state.name} required data-msg="Please enter Store Name" className="input-material" onChange={this.handleInputChange} />
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Role<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <select name="role" value={this.state.role} className="form-control text-capitalize mt-2" required data-msg="Please select role" onChange={this.handleInputChange}>
                                                                <option value="">Select Role</option>
                                                                {roles.length > 0 &&
                                                                    roles.map((role: any, index: any) => (
                                                                        <option key={index} value={role.id}>{role.name}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>


                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Group<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                        {groups.length > 0 &&
                                                                    <Select
                                                                        value={selectedGroup}
                                                                        closeMenuOnSelect={true}
                                                                        name="group"
                                                                        options={groupData}
                                                                        className="basic-multi-select"
                                                                        classNamePrefix="select"
                                                                        onChange={(e: any) => this.handleGroupsInputChange(e)}
                                                                    />
                                                                }
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Address<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="address" type="text" name="address" value={this.state.address} required data-msg="Please enter Store Name" className="input-material" onChange={this.handleInputChange} />
                                                        </div>
                                                    </div>

                                                    {/* Email Info */}
                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Email<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="email" type="email" name="email" value={this.state.email} required data-msg="Please enter Email" className="input-material" onChange={this.validateEmail} />
                                                            {(this.state.isValidEmail == false && this.state.email !== "") &&
                                                            <small className="form-text text-danger">Invalid Email</small>}
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Phone<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="phone" type="text" name="phone" value={this.state.phone} required data-msg="Please enter Phone" className="input-material" onChange={this.validatePhone} onKeyDown={this.handlePhoneKeyPress} />
                                                            {(this.state.isValidPhone == false && this.state.phone !== "") &&
                                                            <small className="form-text text-danger">Invalid Phone Number</small>}
                                                        </div>
                                                    </div>

                                                </div>


                                                <div className="card-header card-header-info d-flex align-items-center">
                                                    <h5>Status Information</h5>
                                                </div>

                                                <div className="form-horizontal p-xl-4">
                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Status<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <select name="status" value={this.state.status} className="form-control text-capitalize mt-2" required data-msg="Please select status" onChange={this.handleInputChange}>
                                                                <option value={config.ACTIVE}>Active</option>
                                                                <option value={config.INACTIVE}>Inactive</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="form-group float-right mt-3">
                                                    <button className='btn btn-primary' disabled={!this.isUserReady()} onClick={this.handleSaveBtnClick}>Update User</button>
                                                </div>
                                            </div>

                                        </div >
                                    </div>
                                </div>
                            </div>
                        </section>
                        <Footer />
                    </div>
                </div>
            </div >
        );
    }
}
const mapStateToProps = (state: any) => {
    console.log("state", state);
    return {
        groups: state.user.groups,
        roles: state.user.roleList,
        user: state.user.userGet,
        courseGroups: state.user.courseGroupList,
        courseGroupsUser: state.user.userCourseGroup,
    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {

        groupList: function () {
            dispatch(groupList())
        },
        roleList: function () {
            dispatch(roleList())
        },
        updateUser: function (id: any, data: any) {
            dispatch(updateUser(id, data));
        },
        getUser: function (id: any) {
            dispatch(getUser(id));
        },
        courseGroupList: function () {
            dispatch(courseGroupList())
        },
        getCourseGroupByUser: function (id: any) {
            dispatch(getCourseGroupByUser(id))
        },
        logoutUser: function () {
            dispatch(logoutUser());
        },
        // storesList: function () {
        //     dispatch(storesList())
        // },
        // addGroup: function (data: any) {
        //     dispatch(addGroupStore(data));
        // }
        // deleteStore: function (id:any) {
        //     dispatch(deleteStore(id))
        // }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditUser);